import { useMutation } from '@tanstack/react-query';
import get from 'lodash/get';

/* Apis */
import { subscriptions } from '@api/apis';

/* Utils */
import { Logger } from '@utils/logger';
import { IHash } from 'types/base.types';

/* Types */
export interface ISubscribe {
  email: string;
  type?: number;
}

type TResponse = {
  errorMessage?: string;
  coupon?: IHash<string>;
  subscription: IHash<number>;
};

export default function useSubscriptionSubscribe() {
  return useMutation<TResponse, unknown, ISubscribe>({
    mutationFn: async ({ type, email }) => {
      const { data } = await subscriptions.subscribe({ type, email });

      if (data.status === 500) throw new Error(data.err);
      if (data.errors) {
        data.errorMessage = get(data, 'errors.0', '');
      }

      return data;
    },
    /* Thrown error goes here: we can roll back if needed */
    onError: error => {
      Logger('useSubscriptionSubscribe')(error as Error);
    },
  });
}
